import { Heading, HStack, Text, Box } from '@medely/ui-kit';
import { ContentLoader } from '@mp/components/ContentLoader';
import useDialog from '@mp/hooks/useDialog';
import React from 'react';
import { useWorkGapsForResumeBuilder, useWorkHistoriesForResumeBuilder } from './graphql';
import { WorkHistoryAndGapMenu } from './menuItem/WorkHistoryAndGapMenu';
import { WorkGapModal } from './workGapModal/WorkGapModal';
import { WorkHistoryModal } from './workHistoryModal/WorkHistoryModal';
import { assign, reverse, sortBy } from 'lodash';
import { WorkHistoryItem } from './workHistoryItem/WorkHistoryItem';

export const Experience = () => {
  const { workHistories, isLoading: isWorkHistoryLoading } = useWorkHistoriesForResumeBuilder();
  const { workGaps, isLoading: isWorkGapLoading } = useWorkGapsForResumeBuilder();
  const workGapModalBehavior = useDialog();
  const workHistoryModalBehavior = useDialog();
  const [selectedExperienceType, setSelectedExperienceType] = React.useState<
    'clinical' | 'nonClinical' | null
  >(null);

  const workHistoryItems = reverse(
    sortBy(
      [...workHistories, ...workGaps?.map((gap) => assign({ isWorkGap: true }, gap))],
      (obj) => obj.start_date,
    ),
  );

  const isLoading = isWorkHistoryLoading || isWorkGapLoading;

  const handleWorkGapClick = () => workGapModalBehavior.openDialog();

  const handleClinicalExperienceClick = () => {
    setSelectedExperienceType('clinical');
    workHistoryModalBehavior.openDialog();
  };

  const handleNonClinicalExperienceClick = () => {
    setSelectedExperienceType('nonClinical');
    workHistoryModalBehavior.openDialog();
  };

  return (
    <Box pb={4}>
      <HStack alignItems="center" justifyContent="space-between" testId="experience">
        <Heading size="s">Experience</Heading>
        <WorkHistoryAndGapMenu
          onWorkGapClick={handleWorkGapClick}
          onWorkHistoryClick={() => undefined}
          onClinicalExperienceClick={handleClinicalExperienceClick}
          onNonClinicalExperienceClick={handleNonClinicalExperienceClick}
        />
      </HStack>
      <Box mb={0.5} />
      <Text size="l" color="text.secondary" testId="experience-text">
        Add at least 2 years of paid clinical experience.
      </Text>
      <Box mb={0.5} />
      <ContentLoader loading={isLoading}>
        <>
          {workHistoryItems.map((workHistoryItem) => (
            <WorkHistoryItem workHistoryItem={workHistoryItem} key={workHistoryItem.id} />
          ))}
        </>
      </ContentLoader>

      <>
        <WorkGapModal open={workGapModalBehavior.open} onClose={workGapModalBehavior.closeDialog} />
        <WorkHistoryModal
          open={workHistoryModalBehavior.open}
          onClose={() => {
            workHistoryModalBehavior.closeDialog();
            setSelectedExperienceType(null);
          }}
          experienceType={selectedExperienceType || undefined}
        />
      </>
    </Box>
  );
};
